import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AclGuard  {

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.check(childRoute);
  }

  check(route: ActivatedRouteSnapshot) {
    const acl = route.data['acl'];

    if (acl === undefined || acl === 'dashboard') {
      return true;
    }

    const isAllowed = this.auth.userPermissions[acl];

    if (!isAllowed) {
      this.router.navigate(['/binu']);
    } else {
      return true;
    }
  }

}
